import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCart } from "../context/CartContext";

const WHATSAPP_NUMARA = "905377981129";
const EPOSTA = "akkuzey@hotmail.com";
// Bileşen dışında tanımlı: render içinde tanımlanırsa her tuş vuruşunda yeniden kurulur
const Etiket = ({ children, zorunlu }) => (
  <span className="mb-1.5 block text-[12.5px] font-medium text-body">
    {children} {zorunlu && <span className="text-accent">*</span>}
  </span>
);

const BIRIMLER = ["adet", "torba", "paket", "kutu", "m²", "m³", "m", "kg", "ton", "litre", "palet"];

/**
 * Toptan / şantiye teklif formu.
 * Bilgiler siteye kaydedilmez: form, ziyaretçinin kendi WhatsApp'ından (ya da e-postasından)
 * gönderdiği düzenli bir mesaja dönüştürülür. Ürün listesi teklif sepetinden gelir, serbest satır eklenebilir.
 */
export default function ToptanTeklif() {
  const { t } = useTranslation();
  const { satirlar } = useCart();

  const [bilgi, setBilgi] = useState({ firma: "", yetkili: "", telefon: "", ilce: "", adres: "", tarih: "", odeme: "", not: "" });
  const [kalemler, setKalemler] = useState([]);
  const [hata, setHata] = useState("");

  useEffect(() => {
    document.title = `${t("quote.title")} — ${t("siteName")}`;
  }, [t]);

  // Sepetteki ürünler forma bir kez aktarılır (sonra formda serbestçe düzenlenir)
  useEffect(() => {
    setKalemler((onceki) =>
      onceki.length
        ? onceki
        : satirlar.length
        ? satirlar.map((s) => ({ ad: s.boyut ? `${s.ad} (${s.boyut})` : s.ad, miktar: String(s.adet), birim: "adet" }))
        : [{ ad: "", miktar: "", birim: "adet" }]
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const alan = (k) => (e) => setBilgi((b) => ({ ...b, [k]: e.target.value }));
  const kalemGuncelle = (i, k, v) => setKalemler((l) => l.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const kalemEkle = () => setKalemler((l) => [...l, { ad: "", miktar: "", birim: "adet" }]);
  const kalemSil = (i) => setKalemler((l) => (l.length > 1 ? l.filter((_, j) => j !== i) : [{ ad: "", miktar: "", birim: "adet" }]));

  const doluKalemler = kalemler.filter((k) => k.ad.trim());

  const mesaj = useMemo(() => {
    const satir = (etiket, deger) => (deger.trim() ? `${etiket}: ${deger.trim()}` : null);
    return [
      t("quote.msgIntro"),
      "",
      satir(t("quote.company"), bilgi.firma),
      satir(t("quote.contact"), bilgi.yetkili),
      satir(t("quote.phone"), bilgi.telefon),
      satir(t("quote.district"), bilgi.ilce),
      satir(t("quote.address"), bilgi.adres),
      satir(t("quote.date"), bilgi.tarih),
      satir(t("quote.payment"), bilgi.odeme ? t(`quote.pay_${bilgi.odeme}`) : ""),
      "",
      `${t("quote.items")}:`,
      ...doluKalemler.map((k, i) => `${i + 1}) ${k.ad.trim()} — ${k.miktar || "?"} ${k.birim}`),
      bilgi.not.trim() ? "" : null,
      satir(t("quote.note"), bilgi.not),
      "",
      t("shop.whatsappOutro"),
    ]
      .filter((x) => x !== null)
      .join("\n");
  }, [bilgi, doluKalemler, t]);

  const kontrol = () => {
    if (!bilgi.firma.trim() && !bilgi.yetkili.trim()) return t("quote.errName");
    if (!bilgi.telefon.trim()) return t("quote.errPhone");
    if (!doluKalemler.length) return t("quote.errItems");
    return "";
  };

  const gonder = (kanal) => (e) => {
    const h = kontrol();
    setHata(h);
    if (h) {
      e.preventDefault();
      return;
    }
    if (kanal === "eposta") {
      e.preventDefault();
      window.location.href = `mailto:${EPOSTA}?subject=${encodeURIComponent(t("quote.mailSubject", { firma: bilgi.firma || bilgi.yetkili }))}&body=${encodeURIComponent(mesaj)}`;
    }
  };

  const girdi = "w-full rounded-lg border border-line bg-white px-3.5 py-2.5 text-[14.5px] text-ink outline-none transition-colors focus:border-ink/40";

  return (
    <section className="container-page section">
      <div className="page-head">
        <p className="eyebrow">{t("quote.eyebrow")}</p>
        <h1 className="page-title mt-3">{t("quote.title")}</h1>
        <p className="mt-3 max-w-2xl text-[15px] leading-relaxed text-body">{t("quote.subtitle")}</p>
      </div>

      <div className="grid gap-8 lg:grid-cols-[1.35fr_1fr]">
        <form onSubmit={(e) => e.preventDefault()} className="space-y-8">
          {/* Firma ve teslimat */}
          <fieldset className="rounded-2xl border border-line bg-white p-6 sm:p-7">
            <legend className="px-1 text-[13px] font-semibold text-ink">{t("quote.stepCompany")}</legend>
            <div className="grid gap-4 sm:grid-cols-2">
              <label><Etiket zorunlu>{t("quote.company")}</Etiket><input className={girdi} value={bilgi.firma} onChange={alan("firma")} autoComplete="organization" /></label>
              <label><Etiket>{t("quote.contact")}</Etiket><input className={girdi} value={bilgi.yetkili} onChange={alan("yetkili")} autoComplete="name" /></label>
              <label><Etiket zorunlu>{t("quote.phone")}</Etiket><input className={girdi} value={bilgi.telefon} onChange={alan("telefon")} type="tel" inputMode="tel" autoComplete="tel" /></label>
              <label><Etiket>{t("quote.district")}</Etiket><input className={girdi} value={bilgi.ilce} onChange={alan("ilce")} placeholder={t("quote.districtPh")} /></label>
              <label className="sm:col-span-2"><Etiket>{t("quote.address")}</Etiket><input className={girdi} value={bilgi.adres} onChange={alan("adres")} autoComplete="street-address" /></label>
              <label><Etiket>{t("quote.date")}</Etiket><input className={girdi} value={bilgi.tarih} onChange={alan("tarih")} type="date" /></label>
              <label>
                <Etiket>{t("quote.payment")}</Etiket>
                <select className={girdi} value={bilgi.odeme} onChange={alan("odeme")}>
                  <option value="">{t("quote.pay_none")}</option>
                  {["nakit", "havale", "kart", "cek"].map((o) => (
                    <option key={o} value={o}>{t(`quote.pay_${o}`)}</option>
                  ))}
                </select>
              </label>
            </div>
          </fieldset>

          {/* Ürün listesi */}
          <fieldset className="rounded-2xl border border-line bg-white p-6 sm:p-7">
            <legend className="px-1 text-[13px] font-semibold text-ink">{t("quote.items")}</legend>
            <p className="mb-4 text-[12.5px] text-muted">{satirlar.length ? t("quote.fromCart") : t("quote.itemsHint")}</p>
            <ul className="space-y-3">
              {kalemler.map((k, i) => (
                <li key={i} className="grid grid-cols-[1fr_90px] gap-2 sm:grid-cols-[1fr_100px_110px_40px]">
                  <input className={`${girdi} col-span-2 sm:col-span-1`} value={k.ad} onChange={(e) => kalemGuncelle(i, "ad", e.target.value)} placeholder={t("quote.itemPh")} aria-label={t("quote.itemName")} />
                  <input className={girdi} value={k.miktar} onChange={(e) => kalemGuncelle(i, "miktar", e.target.value)} inputMode="decimal" placeholder={t("quote.qty")} aria-label={t("quote.qty")} />
                  <select className={girdi} value={k.birim} onChange={(e) => kalemGuncelle(i, "birim", e.target.value)} aria-label={t("quote.unit")}>
                    {BIRIMLER.map((b) => <option key={b} value={b}>{b}</option>)}
                  </select>
                  <button type="button" onClick={() => kalemSil(i)} aria-label={t("compare.remove")} className="hidden rounded-lg border border-line text-muted transition-colors hover:border-accent hover:text-accent sm:block">×</button>
                </li>
              ))}
            </ul>
            <div className="mt-4 flex flex-wrap gap-3">
              <button type="button" onClick={kalemEkle} className="rounded-md border border-line px-4 py-2 text-[13px] font-medium text-ink transition-colors hover:border-ink">
                + {t("quote.addItem")}
              </button>
              <Link to="/urunler" className="rounded-md px-3 py-2 text-[13px] text-muted hover:text-ink">{t("quote.browse")}</Link>
            </div>
          </fieldset>

          <label className="block rounded-2xl border border-line bg-white p-6 sm:p-7">
            <Etiket>{t("quote.note")}</Etiket>
            <textarea className={`${girdi} min-h-[96px]`} value={bilgi.not} onChange={alan("not")} placeholder={t("quote.notePh")} />
          </label>
        </form>

        {/* Önizleme ve gönderim */}
        <aside className="flex flex-col rounded-2xl bg-ink p-6 text-white lg:sticky lg:top-40 lg:self-start sm:p-7">
          <p className="text-[11px] font-semibold uppercase tracking-eyebrow text-white/60">{t("quote.preview")}</p>
          <pre className="mt-4 max-h-[340px] overflow-auto whitespace-pre-wrap rounded-xl bg-white/5 p-4 font-sans text-[13px] leading-relaxed text-white/85">{mesaj}</pre>
          {hata && <p className="mt-3 rounded-md bg-accent/20 px-3 py-2 text-[13px] text-white">{hata}</p>}
          <a
            href={`https://wa.me/${WHATSAPP_NUMARA}?text=${encodeURIComponent(mesaj)}`}
            onClick={gonder("whatsapp")}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center justify-center rounded-md bg-[#25D366] px-4 py-3 text-[14px] font-semibold text-white transition-colors hover:bg-[#1ebe5b]"
          >
            {t("quote.sendWhatsapp")}
          </a>
          <a href={`mailto:${EPOSTA}`} onClick={gonder("eposta")} className="mt-2 inline-flex items-center justify-center rounded-md border border-white/20 px-4 py-2.5 text-[13.5px] font-medium text-white transition-colors hover:bg-white/10">
            {t("quote.sendEmail")}
          </a>
          <p className="mt-4 text-[11.5px] leading-snug text-white/50">{t("quote.privacy")}</p>
        </aside>
      </div>
    </section>
  );
}
